export default "__VITE_ASSET__eb465357__"